<template>
  <div
    :class="{ 'yxtbiz-discuss-speech__item--replay': data.replyCount }"
    class="yxtbiz-discuss-speech__item"
  >
    <div class="yxtbiz-discuss-speech__avatar">
      <yxt-avatar
        :class="{ hand: !isPreview }"
        @click="openUserInfo"
        :imgUrl="data.creatorImageUrl"
        :username="data.creatorName"
        size="48px"
      ></yxt-avatar>
    </div>
    <div class="yxtbiz-discuss-speech__content">
      <div class="yxtbiz-discuss-speech__user-info">
        <yxtf-tooltip
          placement="top"
          effect="dark"
          open-filter
          :content="data.creatorName"
        >
          <yxtbiz-user-name class="ellipsis" :name="data.creatorName" />
        </yxtf-tooltip>
        <yxtf-tooltip
          placement="top"
          effect="dark"
          open-filter
          :content="data.creatorDeptName"
        >
          <yxtbiz-dept-name class="ellipsis" :name="data.creatorDeptName" />
        </yxtf-tooltip>
      </div>
      <div class="yxtbiz-discuss-speech__text">
        <row-clamp :max-lines="2" autoresize class="color-gray-9">
          {{ data.filtered }}
          <template v-if="isSub">
            <span slot="before">
              {{ this.$t('pc_biz_lbl_reply') }}&nbsp;<span
                v-if="data.parentCreatorName"
                class="color-gray-10"
              >
                <yxtbiz-user-name
                  class="user-name ellipsis"
                  :name="data.parentCreatorName"
                />:
              </span>
            </span>
          </template>
        </row-clamp>
      </div>
      <yxtbiz-attachment-list :list="data.attachmentList" />
      <div class="yxtbiz-discuss-speech__comment-info">
        <div class="yxtbiz-discuss-speech__comment-info-left">
          <span>{{ friendlyDateBeforeFilter(data.createTime) }}</span>
          <span
            v-if="data.replyCount"
            class="yxtbiz-discuss-speech__comment-info-view"
            @click="toggleReplay"
            >{{
              $t(
                replayVisible
                  ? 'pc_biz_discuss_hide_replay_with_count'
                  : 'pc_biz_discuss_view_replay_with_count',
                [data.replyCount]
              )
            }}</span
          >
        </div>
        <div class="yxtbiz-discuss-speech__comment-info-right">
          <span
            v-if="!isPreview && !data.mine && enableComplain"
            class="mr24 flex-align-center hover-primary-6 hand"
            @click="addCommentComplain"
          >
            <yxt-svg
              class="mr2 hover-primary-6"
              height="16px"
              icon-class="tip-offs"
              width="16px"
            />
            {{ $t('pc_biz_complain_title').d('举报') }}
          </span>
          <span
            v-if="!isPreview && data.mine"
            class="mr24 flex-align-center hover-primary-6 hand"
            @click="deleteReply(data)"
          >
            <yxt-svg
              :remote-url="svgUrl"
              class="mr2 hover-primary-6"
              height="16px"
              icon-class="delete"
              width="16px"
            />
            {{ $t('pc_common_cate_delete').d('删除') }}
          </span>
          <span
            :class="{ 'hand hover-primary-6': !isPreview }"
            class="mr24 flex-align-center"
            @click="replayComment"
          >
            <template v-if="!isPreview">
              <yxt-svg
                :remote-url="svgUrl"
                class="mr2 hover-primary-6"
                height="16px"
                icon-class="icon-comment"
                width="16px"
              />
              {{ $t('pc_biz_lbl_reply').d('回复') }}
            </template>
            <span v-else>{{
              $t('pc_bbs_lbl_replayName', [data.replyCount])
            }}</span>
          </span>
          <span class="flex-align-center" @click="praises(data)">
            <template v-if="!isPreview">
              <yxtf-action-icon
                class="hand"
                size="32px"
                light
                :actived="!!data.userPraised"
                :readonly="!!data.userPraised"
              />
              <!--              <yxt-svg-->
              <!--                :icon-class="-->
              <!--                  data.userPraised ? 'icon-thumb-active' : 'icon-thumb'-->
              <!--                "-->
              <!--                :remote-url="svgUrl"-->
              <!--                class="mr2 hand hover-primary-6"-->
              <!--                height="16px"-->
              <!--                width="16px"-->
              <!--              />-->
              {{ data.praiseCount }}
            </template>

            <span v-else>
              {{ $t('pc_biz_lbl_praise_count', [data.praiseCount]) }}
            </span>
          </span>
        </div>
      </div>
      <transition name="yxt-fade-in-linear">
        <div
          v-if="replayCommentVisible"
          class="yxtbiz-discuss-speech__replay__area"
        >
          <yxt-input
            v-model="replayContent"
            :placeholder="$t('pc_biz_lbl_reply').d('回复') + data.creatorName"
            maxlength="2000"
            minlength="5"
            rows="2"
            show-word-limit
            type="textarea"
          ></yxt-input>
          <div class="yxtbiz-discuss-speech__replay__area__action">
            <div>
              <yxt-checkbox
                v-if="allowAnonymous"
                v-model="replayAnonymous"
                :false-label="0"
                :true-label="1"
                >{{ $t('pc_biz_bbs_lbl_anonymous').d('匿名') }}
              </yxt-checkbox>
            </div>

            <div>
              <yxt-button @click="closeReplayComment">{{
                $t('pc_biz_common_cancel_mini').d('取消')
              }}</yxt-button>
              <yxt-button
                :loading="replayLoading"
                :disabled="replayContent.length < 5"
                type="primary"
                @click="submitReplay(data)"
                >{{ $t('pc_biz_complain_submit').d('提交') }}
              </yxt-button>
            </div>
          </div>
        </div>
      </transition>
      <transition name="yxt-fade-in-linear">
        <div
          v-if="data.replyCount"
          v-show="replayVisible"
          v-loading="loading"
          class="yxtbiz-discuss-speech__replay"
        >
          <Speech
            v-for="replay in replayList"
            :key="replay.id"
            :ccConfig="ccConfig"
            :data="replay"
            :orderby="orderby"
            is-sub
            v-bind="$props"
            @on-delete="onSpeechDelete"
            @on-replay="onSpeechReplay"
            @get-parent-replay="refresh"
          ></Speech>
          <yxtf-pagination
            :current-page="currentPage"
            :page-size="pageSize"
            :page-sizes="[10, 20, 30, 40]"
            :total="totalCount"
            class="mt12 layout-flex layout-justify-end"
            layout="total, prev, pager, next"
            simple-total
            @current-change="handleCurrentChange"
          >
          </yxtf-pagination>
        </div>
      </transition>
    </div>
    <yxtbiz-complain ref="complain" :target="complainTarget" />
  </div>
</template>

<script>
import { friendlyDateBeforeFilter } from './utils';
import {
  createReplay,
  deleteComment,
  getReplay,
  praises,
  recordDiscussPraise
} from 'yxt-biz-pc/packages/discuss-speech/src/service';
import rowClamp from 'yxt-biz-pc/packages/discuss-speech/src/clamp/rowClamp';

export default {
  name: 'Speech',
  data() {
    return {
      replayVisible: false,
      replayCommentVisible: false,
      replayContent: '',
      replayAnonymous: 0,
      replayList: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      // orderby: 'createTime', // praiseCount
      replayLoading: false,
      complainTarget: {}
    };
  },
  props: {
    data: {
      type: Object,
      default: {}
    },
    orderby: {
      type: String,
      default: 'createTime'
    },
    isSub: Boolean,
    isPreview: Boolean,
    boardId: String,
    questionId: String,
    allowAnonymous: Boolean,
    targetCode: String,
    discussTargetId: String,
    isUserSilence: Boolean,
    ccConfig: {
      type: Object,
      default: {}
    }
  },
  computed: {
    svgUrl() {
      return `${this.$staticBaseUrl}ufd/55a3e0/o2o/pc/svg`;
    },
    enableComplain() {
      // 项目讨论任务 MK0006-GN0008-2
      // 课程讨论任务	MK0007-GN0008-2
      return this.targetCode === 'kng'
        ? this.ccConfig['MK0007-GN0008-2']
        : this.ccConfig['MK0006-GN0008-2'];
    }
  },
  watch: {
    orderby(val) {
      this.currentPage = 1;
      if (this.replayVisible) {
        this.getReplay();
      }
    }
  },
  components: {
    rowClamp
  },
  methods: {
    friendlyDateBeforeFilter,
    toggleReplay() {
      this.replayVisible = !this.replayVisible;
      if (this.replayVisible) {
        this.getReplay();
      }
    },
    getReplay() {
      const query = {
        rootId: this.data.id,
        postId: this.data.targetId,
        orderby: this.orderby,
        limit: this.pageSize,
        offset: (this.currentPage - 1) * this.pageSize
      };
      this.loading = true;
      getReplay(this.data.id, query)
        .then(result => {
          console.log(result);
          this.replayList = result.datas;
          this.data.replyCount = result.paging.count;
          this.totalCount = result.paging.count;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSpeechDelete() {
      this.refresh();
    },
    onSpeechReplay() {
      this.$emit('on-replay');
    },
    refresh() {
      this.currentPage = 1;
      this.getReplay();
    },
    replayComment() {
      if (this.isPreview) return;
      if (this.isUserSilence) {
        this.$message.warning(
          this.$t('pc_bbs_global_tip_forbidden').d(
            '您已被禁言，暂不可发表任何言论。如需取消禁言，请与管理员联系'
          )
        );
        return;
      }
      this.replayCommentVisible = true;
    },
    closeReplayComment() {
      this.replayCommentVisible = false;
    },
    submitReplay(data) {
      if (this.replayContent.trim().length === 0) {
        this.$message.error(
          this.$t('pc_biz_discuss_replay_not_blank').d('回复内容不能为空')
        );
        return;
      }
      const params = {
        boardId: data.extId,
        anonymous: this.replayAnonymous,
        content: this.replayContent,
        targetId: this.questionId,
        type: 1,
        targetType: this.targetCode === 'kng' ? 15 : 14,
        parentId: data.id,
        targetCode: this.targetCode,
        discussTargetId: this.discussTargetId,
        createCommentUserId: data.creator
      };
      console.log(params);
      this.replayLoading = true;
      createReplay(params)
        .then(res => {
          console.log('create success');
          this.closeReplayComment();
          if (this.isSub) {
            this.$emit('get-parent-replay');
          } else {
            this.showReplay();
          }
          this.clearReplayContent();
          this.$emit('on-replay');
        })
        .catch(error => {
          console.log(error);
          if (error && error.error && error.error.message) {
            this.$message.error(error.error.message);
          }
        })
        .finally(() => {
          this.replayLoading = false;
        });
    },
    showReplay() {
      this.replayVisible = true;
      this.getReplay();
    },
    clearReplayContent() {
      this.replayContent = '';
      this.replayAnonymous = 0;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getReplay();
    },
    deleteReply(data) {
      this.$confirm(
        this.$t('pc_biz_discuss_delete_replay_confirm').d('确定要删除回复吗？'),
        this.$t('pc_biz_ai_confirmDelete' /* 确认删除 */),
        {
          confirmButtonText: this.$t('pc_biz_common_btn_sure').d('确定'),
          cancelButtonText: this.$t('pc_biz_common_cancel_mini').d('取消'),
          type: 'warning'
        }
      )
        .then(() => {
          deleteComment({
            id: data.id,
            targetId: this.questionId,
            targetType: this.targetCode === 'kng' ? 15 : 14,
            type: this.isSub ? 2 : 1
          })
            .then(() => {
              this.$emit('on-delete');
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(_ => {});
    },
    praises(data) {
      if (this.isPreview) return;
      if (data.userPraised) {
        this.$message.warning(
          this.$t('pc_bbs_detail_tip_praised').d('你已经点过赞了~')
        );
        return;
      }
      const params = {
        praiseType: 1,
        remark: '',
        targetId: data.id,
        targetOrgId: data.orgId,
        targetType: 7
      };
      praises(params)
        .then(result => {
          data.userPraised = 1;
          data.praiseCount += 1;
          if (this.isSub) return;
          const recordParams = {
            createCommentUserId: this.data.creator,
            postId: this.questionId,
            boardId: this.boardId,
            targetCode: this.targetCode,
            targetId: this.discussTargetId
          };
          recordDiscussPraise(recordParams)
            .then(result => {
              console.log('recordDiscussPraise  success');
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(error => {
          console.log(error);
        });
    },
    addCommentComplain() {
      if (!this.enableComplain) {
        this.$message.error(
          this.$t('pc_bbs_cc_tip_complainClosed').d('举报功能已关闭！')
        );
        return;
      }
      const COMPLAIN_TARGET_TYPE = this.targetCode === 'kng' ? 17 : 16; // 项目 16  课程17
      const COMPLAIN_MASTER_TYPE = this.targetCode === 'kng' ? 18 : 17;
      this.complainTarget = {
        masterId: this.questionId,
        masterType: COMPLAIN_MASTER_TYPE,
        targetId: this.data.id,
        targetInfo: this.$t(
          'pc_bbs_lbl_name_comments',
          [this.data.creatorName] /* {name}的评论 */
        ),
        targetName: this.data.filtered.substring(0, 1000),
        targetType: COMPLAIN_TARGET_TYPE,
        audioUrl: '',
        audioLength: 0,
        logoUrl: this.data.images,
        targetCreator: this.data.creator
      };
      this.$refs.complain.visible = true;
    },
    openUserInfo() {
      if (this.isPreview) return;
      if (this.data.creator) {
        window.open(
          `${window.location.origin}/study/#/userindex?userId=${
            this.data.creator
          }`
        );
      }
    }
  }
};
</script>
